import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { FunctionComponent } from 'react';
import HeaderTableColumn from './HeaderTableColumn';
import styles from './DaycareHeaderTable.module.scss';
import {
    bookedAtSorter,
    clientSorter,
    petSorter,
    roomSorter,
    serviceSorter,
    statusSorter,
    totalSorter
} from './sorting';
import { Sorter } from '@spike/appointments-list-model';

interface DaycareHeaderTableProps {
    sorter: Sorter | null;
    onSort?: (sorter: Sorter) => void;
    allSelected?: boolean;
    onToggleSelectAll?: (checked: boolean) => void;
}

export const DaycareHeaderTable: FunctionComponent<DaycareHeaderTableProps> = props => {
    return (
        <TableHeader>
            {props.onToggleSelectAll && (
                <TableHeaderCell className={styles.checkboxCell}>
                    <Checkbox
                        checked={props.allSelected}
                        onChange={props.onToggleSelectAll}
                    />
                </TableHeaderCell>
            )}
            <HeaderTableColumn
                columnSorter={clientSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={petSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serviceSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={roomSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Room
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={bookedAtSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Date & Time
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={totalSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={statusSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Status
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default DaycareHeaderTable;
